<template>
  <div>
    <!-- <h3 class="mb-2">샘플 마스터 관리</h3> -->
    <v-form ref="sampleMaster" lazy-validation>
      <div class="filter-box filter-box--row">
        <ul class="filter-list" style="width: 80%">
          <li>
            <h4>Solvent</h4>
            <v-text-field v-model="param.solvent" outlined dense placeholder="solvent/solvent/solvent/solvent/solvent/solvent/solvent/solvent" :rules="[this.validSet.sample(param.solvent, 8, 'key')]" @keyup.enter="search"></v-text-field>
          </li>
          <li>
            <h4>Solvent vol</h4>
            <v-text-field v-model="param.solventVol" outlined dense placeholder="00.00/00.00/00.00/00.00/00.00/00.00/00.00/00.00" :rules="[this.validSet.sample(param.solventVol, 8, 'value')]" @keyup.enter="search"></v-text-field>
          </li>
          <li>
            <h4>Salt</h4>
            <v-text-field v-model="param.salt" outlined dense placeholder="salt/salt/salt" :rules="[this.validSet.sample(param.salt, 2, 'key')]" @keyup.enter="search"></v-text-field>
          </li>
          <li>
            <h4>Salt vol</h4>
            <v-text-field v-model="param.saltVol" outlined dense placeholder="00.00/00.00/00.00" :rules="[this.validSet.sample(param.saltVol, 2, 'value')]" @keyup.enter="search"></v-text-field>
          </li>
          <li>
            <h4>Add</h4>
            <v-text-field v-model="param.add" outlined dense placeholder="add/add/add/add/add/add/add/add/add/add" :rules="[this.validSet.sample(param.add, 9, 'key')]" @keyup.enter="search"></v-text-field>
          </li>
          <li>
            <h4>Add vol</h4>
            <v-text-field v-model="param.addVol" outlined dense placeholder="00.00/00.00/00.00/00.00/00.00/00.00/00.00/00.00/00.00/00.00" :rules="[this.validSet.sample(param.addVol, 9, 'value')]" @keyup.enter="search"></v-text-field>
          </li>
          <li>
            <h4>Code Grade</h4>
            <v-text-field v-model="param.code" outlined dense placeholder="" :rules="[this.validSet.commonCodeHipen]" @keyup.enter="search"></v-text-field>
          </li>
          <li>
            <h4>양산자재 코드</h4>
            <v-text-field v-model="param.mass_code" outlined dense placeholder="" @keyup.enter="search"></v-text-field>
          </li>
          <li>
            <h4>제품자재 코드</h4>
            <v-text-field v-model="param.product_code" outlined dense placeholder="" @keyup.enter="search"></v-text-field>
          </li>
          <li>
            <h4>Non-PFE 코드</h4>
            <v-text-field v-model="param.non_pfe_code" outlined dense placeholder="" @keyup.enter="search"></v-text-field>
          </li>
        </ul>
        <div class="btn-box">
          <v-card-actions>
            <v-btn depressed class="btn-reset" @click="reset">초기화</v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn depressed class="btn-search" @click="search">검색</v-btn>
          </v-card-actions>
        </div>
        <!-- <v-col cols="12" sm="1" style="align-self: end">
          <div class="wrapperEnd pr-2">
            <v-card-actions>
              <v-btn depressed outlined @click="reset">초기화</v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-btn depressed color="primary" @click="search">검색</v-btn>
            </v-card-actions>
          </div>
        </v-col> -->
      </div>

      <!-- <v-row class="sch pl-2 mb-2">
        <v-col cols="12" sm="10">
          <div class="sampleMaster wrapperSpace">
            <v-col cols="12" sm="6">
              <h4>Solvent</h4>
              <v-text-field
                v-model="param.solvent"
                outlined
                dense
                placeholder="solvent/solvent/solvent/solvent/solvent/solvent/solvent/solvent"
                :rules="[this.validSet.sample(param.solvent, 8, 'key')]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <h4>Solvent vol</h4>
              <v-text-field
                v-model="param.solventVol"
                outlined
                dense
                placeholder="00.00/00.00/00.00/00.00/00.00/00.00/00.00/00.00"
                :rules="[this.validSet.sample(param.solventVol, 8, 'value')]"
              ></v-text-field>
            </v-col>
          </div>
          <div class="sampleMaster wrapperSpace">
            <v-col cols="12" sm="6">
              <h4>Salt</h4>
              <v-text-field
                v-model="param.salt"
                outlined
                dense
                placeholder="salt/salt/salt"
                :rules="[this.validSet.sample(param.salt, 2, 'key')]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <h4>Salt vol</h4>
              <v-text-field
                v-model="param.saltVol"
                outlined
                dense
                placeholder="00.00/00.00/00.00"
                :rules="[this.validSet.sample(param.saltVol, 2, 'value')]"
              ></v-text-field>
            </v-col>
          </div>
          <div class="sampleMaster wrapperSpace">
            <v-col cols="12" sm="6">
              <h4>Add</h4>
              <v-text-field
                v-model="param.add"
                outlined
                dense
                placeholder="add/add/add/add/add/add/add/add/add/add"
                :rules="[this.validSet.sample(param.add, 9, 'key')]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <h4>Add vol</h4>
              <v-text-field
                v-model="param.addVol"
                outlined
                dense
                placeholder="00.00/00.00/00.00/00.00/00.00/00.00/00.00/00.00/00.00/00.00"
                :rules="[this.validSet.sample(param.addVol, 9, 'value')]"
              ></v-text-field>
            </v-col></div></v-col
        ><v-col cols="12" pl-2 sm="2" style="align-self: end">
          <div class="wrapperEnd pr-4">
            <v-card-actions>
              <v-btn depressed outlined @click="reset">초기화</v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-btn depressed color="primary" @click="search">검색</v-btn>
            </v-card-actions>
          </div></v-col
        ></v-row
      > -->
    </v-form>

    <div class="wrapper">
      <div class="btn-box mt-2 mb-2">
        <v-btn depressed color="primary" @click="openMassRatioCalculation" style="width: 143px; margin-left: auto">질량비 계산</v-btn>
        <v-btn depressed color="primary" @click="exelDownload" style="width: 143px">엑셀 다운로드</v-btn>
        <v-btn depressed color="primary" @click="exelDownloadAll" style="width: 143px">엑셀 전체 다운로드</v-btn>
        <v-btn style="margin-left: auto" depressed class="btn-add" @click="addSample">등록</v-btn>
      </div>
    </div>

    <!-- <h3 class="mt-8 mb-2 pl-1 pr-1">
      <div class="wrapperSpace">
        샘플 목록
        <v-btn depressed color="primary" @click="addSample">등록</v-btn>
      </div>
    </h3>
    <hr class="mb-4" /> -->
    <RealGrid :domName="grid" ref="grid" :settings="settings" @changePage="search" @dbClick="dbClick" />

    <!-- 전체 다운로드용 숨겨진 그리드 -->
    <div style="display: none;">
      <RealGrid :domName="gridAll" ref="gridAll" :settings="settingsAll" />
    </div>

    <!-- 페이징 -->
    <div class="pagination-container" v-if="pagination.totalRows > 0" :key="`pagination-${pagination.currentPage}`">
      <v-pagination :value="pagination.currentPage" :length="Math.ceil(pagination.totalRows / pagination.pageSize)" :total-visible="7" @input="handlePageChange" circle></v-pagination>
    </div>
  </div>
</template>
<script>
import { columns, fields, rows } from '@/assets/grid/sampleMaster';
import { sampleMasterList, sampleMasterListAll } from 'api/sample/sample';
import { getExcel } from 'api/file';
import SetPopup from '@/components/SetPopup.vue';
import RealGrid from '@/components/RealGrid.vue';
import _ from 'lodash';
import validSet from '@/assets/valid';
export default {
  data() {
    return {
      isFetching: false,
      isDataLoaded: false,
      validSet,
      param: {
        solvent: '',
        solventVol: '',
        salt: '',
        saltVol: '',
        add: '',
        addVol: '',
        code: '',
        mass_code: '',
        product_code: '',
        non_pfe_code: '',
        pageSize: 50,
        currentPage: 1,
      },
      grid: 'sampleMaster',
      settings: {
        columns,
        fields,
        rows,
        height: 590,
        noneNo: true,
        hideCheckBar: false,
        fixCol: 1,
      },
      // 전체 다운로드용 그리드 설정
      gridAll: 'sampleMasterAll',
      settingsAll: {
        columns,
        fields,
        rows,
        height: 400,
        noneNo: true,
        hideCheckBar: true,
        fixCol: 1,
      },
      currentPage: 1,
      gridData: [],
      gridDataAll: [],
      // 페이징 관련 데이터
      pagination: {
        currentPage: 1,
        pageSize: 50,
        totalRows: 0,
      },
    };
  },
  methods: {
    newSample() {
      this.$emit('newSample');
    },
    exelDownload() {
      console.log(this.settings, 'settings');
      console.log(this.settings.columns, 'columns');
      console.log(this.settings.fields, 'fields');

      const data = this.$refs.grid.getCheckedRowExecl(this.settings.columns);
      console.log(data, 'data');
      if (data.length > 0) {
        getExcel(data, '샘플마스터');
      } else {
        this.openPopup('엑셀 다운로드할 행을 선택해주세요');
      }
    },
    async exelDownloadAll() {
      try {
        console.log('전체 다운로드 시작');
        
        // 검색조건 없이 전체 조회 (페이징 없이)
        const res = await sampleMasterListAll({
          solvent: '',
          solventVol: '',
          salt: '',
          saltVol: '',
          add: '',
          addVol: '',
          code: '',
          mass_code: '',
          product_code: '',
          non_pfe_code: '',
          pageSize: 99999, // 전체 데이터 조회를 위해 큰 값 설정
          currentPage: 1,
        });

        const response = res.data;
        const items = response.data.items;

        console.log('전체 데이터 조회 완료:', items.length, '건');

        // employee_status를 work로 매핑
        _.each(items, function (v) {
          v.work = v.employee_status;
        });

        // 전체 데이터를 gridAll에 바인딩
        this.gridDataAll = items;
        this.$refs.gridAll.loadData(items);

        console.log('그리드에 데이터 바인딩 완료');

        // 약간의 지연 후 엑셀 다운로드 실행 (그리드 렌더링 대기)
        setTimeout(() => {
          const gridView = this.$refs.gridAll.gv;
          if (gridView) {
            // 리얼그리드의 exportGrid 메소드를 사용하여 엑셀 다운로드
            gridView.exportGrid({
              type: 'excel',
              target: 'local',
              fileName: '샘플마스터_전체.xlsx',
              done: function () {
                console.log('전체 엑셀 다운로드 완료');
              },
            });
          }
        }, 500);
      } catch (err) {
        console.error('전체 다운로드 오류:', err);
        alert('전체 다운로드 중 오류가 발생했습니다.');
      }
    },
    valid() {
      return this.$refs.sampleMaster.validate();
    },
    loadData(v) {
      this.search(v);
    },
    async search(v) {
      if (!this.valid()) return;
      if (this.isFetching) return;
      this.isFetching = true;

      try {
        if (_.isNumber(v)) {
          // 페이지 번호가 전달된 경우 (페이징 버튼 클릭)
          this.currentPage = v;
          this.param.currentPage = v;
        } else {
          // 검색 버튼 클릭 또는 엔터키로 검색하는 경우 페이지 초기화
          this.currentPage = 1;
          this.param.currentPage = 1;
          this.pagination.currentPage = 1;
        }
        const res = await sampleMasterList({
          ...this.param,
          currentPage: this.currentPage,
        });
        this.isDataLoaded = true;

        const response = res.data;
        const items = response.data.items;
        const page = response.data.params;

        _.each(items, function (v) {
          v.work = v.employee_status;
        });

        this.gridData = items;
        this.$refs.grid.loadData(items);
        this.$refs.grid.setPage(page);

        // 페이징 정보 업데이트 (데이터 로드 후)
        this.$nextTick(() => {
          this.pagination = {
            currentPage: parseInt(page.currentPage) || 1,
            totalRows: parseInt(page.totalRows) || 0,
            pageSize: parseInt(page.pageSize) || 50,
          };
        });
      } catch (err) {
        this.error = err.message;
      } finally {
        this.isFetching = false;
      }
    },
    addSample() {
      this.$emit('sampleAdd');
    },
    openMassRatioCalculation() {
      // 선택된 로우 가져오기
      const selectedRows = this.$refs.grid.gv.getCheckedRows(true, false, false);
      if (selectedRows.length === 0) {
        this.showAlert('질량비 계산을 위해 샘플을 선택해주세요.');
        return;
      }
      // 리얼그리드는 체크된 로우 데이터를 가져올때 그리드가 아닌 dp에서 가져와야함, gv에서 정렬 후 가져올 시 다른 데이터 가져옴
      // 다른 메뉴들은 기존에 gv에서 가져오는 로직이므로 추후 수정이 필요
      const selectedRow = this.$refs.grid.dp.getJsonRow(selectedRows[0], false);

      if (selectedRows.length > 1) {
        this.showAlert('질량비 계산은 하나의 샘플만 선택해주세요.');
        return;
      }

      const codeGrade = selectedRow.code;

      if (!codeGrade) {
        this.showAlert('선택된 샘플의 Code Grade가 없습니다.');
        return;
      }

      // 질량비 계산 탭 열기
      this.$emit('openMassRatioCalculation', {
        codeGrade: codeGrade,
        sampleData: selectedRow,
      });
    },
    showAlert(message) {
      alert(message);
    },
    // 페이지 변경 핸들러
    handlePageChange(page) {
      this.currentPage = page;
      this.param.currentPage = page;
      this.pagination.currentPage = page;
      this.$nextTick(() => {
        this.search(page);
      });
    },
    reset() {
      this.param = {
        solvent: '',
        solventVol: '',
        salt: '',
        saltVol: '',
        add: '',
        addVol: '',
        code: '',
        mass_code: '',
        product_code: '',
        non_pfe_code: '',
        pageSize: 50,
        currentPage: 1,
      };
      this.currentPage = 1;
      // 페이징 정보 초기화
      this.pagination.currentPage = 1;
      this.pagination.totalRows = 0;
    },
    dbClick(v) {
      this.$emit('sampleMasterDetail', v);
    },
  },
  components: {
    RealGrid,
    // eslint-disable-next-line vue/no-unused-components
    SetPopup,
  },
  mounted() {
    this.loadData();
  },
};
</script>
<style lang="scss">
.sampleMaster {
  height: 80px;
  padding-left: 10px;
}

// 페이징 컨테이너 스타일
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
</style>
